export default __webpack_public_path__ + "static/media/backPanelTokens.c545d8bf.svg";